import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import { normalQuotation } from "../../../lib/config";
import {
  setCartJourney,
  setSelectedQuotationForm,
  setShowMobileIstand,
} from "../../../redux/actions/cartAction";
import { setCarPopup } from "../../../redux/actions/globalAction";


export const URL = "/assets/repair/repair.svg";

const RepairSelection = ({
  variants,
  setCartJourney,
  setSelectedQuotationForm,
  cart,
  setShowMobileIstand,
  globalData,
  setCarPopup
}) => {
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);

  useEffect(() => {
    var half_length = Math.ceil(variants?.length / 2);
    var leftSide = variants?.slice(0, half_length);
    var rightSide = variants?.slice(half_length);

    setList1(rightSide);
    setList2(leftSide);
  }, [variants]);

  const handleItemClick = (item) => {
    if (!globalData.carData) {
      setCarPopup("brand");
    }
    if (item.IslandType === normalQuotation) {
      if (isMobile) {
        setShowMobileIstand(true);
      }
      localStorage.setItem("product-id", JSON.stringify(item.Id));
      setCartJourney(normalQuotation);
      setSelectedQuotationForm(item);
    }
  };

  return (
    <>
      <Row className="text-center mt-3">
        {/* {list1.map((item) => (
          <Col>
            <button className="repair-btn w-100" onClick={() => handleItemClick(item)}>{item.Name}</button>
          </Col>
        ))} */}
      </Row>
      <Row>
        <Col className="text-center">
          <img src={URL} width="80%" alt="ob-image"/>
        </Col>
      </Row>
      <Row className="text-center mt-3">
        {/* {list2.map((item) => (
          <Col>
            <button className="repair-btn w-100" onClick={() => handleItemClick(item)}>{item.Name}</button>
          </Col>
        ))} */}
        {list1.map((item) => (
          <Col sm={6} className="mt-2">
            {/* {globalData.carData ? ( */}
            <button
              className={
                cart.selectedQuotationForm?.Id == item?.Id
                  ? "repair-btn w-100 bg-primary"
                  : "repair-btn w-100"
              }
              onClick={() => handleItemClick(item)}
            >
              {item.Name}
            </button>
            {/* ) : (
              <ChooseCar
                style={"repair-btn w-100"}
                text={item.Name}
                textTrue={true}
              />
            )} */}
          </Col>
        ))}
        {list2.map((item) => (
          <Col sm={6} className="mt-2">
            <button
              className={
                cart.selectedQuotationForm?.Id == item?.Id
                  ? "repair-btn w-100 bg-primary"
                  : "repair-btn w-100"
              }
              onClick={() => handleItemClick(item)}
            >
              {item.Name}
            </button>
          </Col>
        ))}
      </Row>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    globalData: state.globalData,
    apiData: state.apiData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCartJourney: (stage) => {
      dispatch(setCartJourney(stage));
    },
    setSelectedQuotationForm: (item) => {
      dispatch(setSelectedQuotationForm(item));
    },
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    setCarPopup: (flag) => {
      dispatch(setCarPopup(flag));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RepairSelection);
